import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';

/**
 * Pantalla de éxito (README diseño, sección 5.9): código de seguimiento +
 * QR real (antes se ofrecía reenviar por WhatsApp/correo — simulado, sin
 * integración real — ya se eliminó de este flujo, ver HU-002 Fase 5).
 * El QR codifica el propio código de ticket (texto plano) — la URL pública
 * de consulta por ticket todavía no existe como página propia fuera del
 * wizard, así que por ahora el valor es el código, no un link.
 */
const PasoExito = ({ ticket, resumen, onVerTicket, onVolverAlMapa }) => {
  const [copiado, setCopiado] = useState(false);

  const copiarCodigo = async () => {
    try {
      await navigator.clipboard.writeText(ticket);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    } catch {
      setCopiado(false);
    }
  };

  const descargar = () => {
    const canvas = document.querySelector('.pe-qr-svg-wrapper canvas, .pe-qr-svg-wrapper svg');
    if (!canvas) return;
    if (canvas.tagName.toLowerCase() === 'canvas') {
      const link = document.createElement('a');
      link.download = `ticket-${ticket}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
      return;
    }
    // Fallback para <svg>: serializar y descargar como .svg
    const serializer = new XMLSerializer();
    const svgBlob = new Blob([serializer.serializeToString(canvas)], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(svgBlob);
    const link = document.createElement('a');
    link.download = `ticket-${ticket}.svg`;
    link.href = url;
    link.click();
    URL.revokeObjectURL(url);
  };

  const compartir = async () => {
    const texto = `Mi código de seguimiento en Cifra Negra: ${ticket}`;
    if (navigator.share) {
      try { await navigator.share({ text: texto }); } catch { /* usuario canceló */ }
    } else {
      copiarCodigo();
    }
  };

  return (
    <div className="ex-pantalla">
      <div className="ex-encabezado">
        <i className="fas fa-check-circle"></i>
        <span>Reporte enviado</span>
      </div>

      <div className="ex-tarjeta">
        <span className="ex-etiqueta">TU CÓDIGO DE SEGUIMIENTO</span>
        <div className="ex-codigo">{ticket}</div>

        <div className="ex-qr-wrapper pe-qr-svg-wrapper">
          <QRCodeSVG value={ticket} size={150} />
        </div>
        <p className="ex-qr-leyenda">Escanea o guarda este código</p>

        <div className="ex-separador"></div>

        <div className="ex-acciones">
          <button type="button" onClick={descargar}><i className="fas fa-download"></i> Descargar</button>
          <button type="button" onClick={copiarCodigo}>
            <i className="fas fa-copy"></i> {copiado ? '¡Copiado!' : 'Copiar'}
          </button>
          <button type="button" onClick={compartir}><i className="fas fa-share-alt"></i> Compartir</button>
        </div>
      </div>

      <div className="ex-resumen">
        <p>{resumen}</p>
      </div>

      <p className="ex-aviso">
        Este código es la única forma de dar seguimiento a tu reporte — guárdalo bien.
      </p>

      <div className="ex-botones-finales">
        <button type="button" className="rw-boton-primario" onClick={onVerTicket}>Ver mi ticket</button>
        <button type="button" className="rw-boton-secundario" onClick={onVolverAlMapa}>Volver al mapa</button>
      </div>
    </div>
  );
};

export default PasoExito;
